import React from 'react';
import Link from 'next/link';
import ArrowRight from '../../atoms/Icons/ArrowRight';

export interface IBreadcrumbs {
  name: string;
  path?: string;
  cssClassname?: string;
}

export interface IBreadcrumbsProps {
  isMobileScreen?: boolean;
  items: IBreadcrumbs[];
  breadcrumbsClassName?: string;
  containerClassName?: string;
  position?: string;
  isCMS?: boolean;
  isNotElipsis?: boolean;
  isUsingDefaultAnchor?: boolean;
}

const BreadCrumbs = ({
  isMobileScreen = true,
  items = [],
  breadcrumbsClassName = '',
  containerClassName = 'md:container',
  position = 'md:top-[105px] lg:top-[125px] xl:top-[124px] px-5',
  isCMS = false,
  isNotElipsis = true,
  isUsingDefaultAnchor = false,
}: IBreadcrumbsProps) => {
  return (
    <nav
      className={`${breadcrumbsClassName} w-full ${
        isMobileScreen
          ? 'p-4 lg:hidden'
          : isCMS
            ? 'hidden'
            : `hidden sticky py-3.5 bg-white z-30 lg:block md:border-b md:border-reliableBlack10 ${position}`
      }`}
      aria-label="Breadcrumb"
    >
      <ul
        data-testid="breadcrumb"
        className={`hideScrollBar xl:px-0 flex items-center md:space-x-3 overflow-x-auto ${containerClassName}`}
      >
        {items?.map((item, index) => (
          <li key={index} className="flex items-center">
            {index !== 0 && (
              <span className="w-[18px] md:-ml-1">
                <ArrowRight size={18} fill="#7B7979" />
              </span>
            )}
            {index === items.length - 1 ? (
              <span
                id={`${isMobileScreen ? 'mobile-' : ''}link-breadcrumb-${item.name}`}
                className={`${item.cssClassname ? item.cssClassname : ''}  text-black text-xs uppercase font-bold md:ml-2 ${isNotElipsis ? 'block whitespace-nowrap' : 'text-ellipsis line-clamp-1 '} lg:text-sm`}
              >
                {item.name}
              </span>
            ) : isUsingDefaultAnchor ? (
              <a
                id={`${isMobileScreen ? 'mobile-' : ''}link-breadcrumb-${item.name}`}
                href={item?.path}
                aria-label={`breadcrumb ${item.name} link`}
              >
                <div
                  className={`text-black whitespace-nowrap text-xs uppercase font-medium hover:text-gray-900 lg:text-sm ${
                    index !== 0 && 'md:ml-2'
                  }`}
                >
                  <span
                    className={`${item.cssClassname ? item.cssClassname : ''}`}
                    suppressHydrationWarning={true}
                  >
                    {item.name}
                  </span>
                </div>
              </a>
            ) : (
              <Link
                id={`${isMobileScreen ? 'mobile-' : ''}link-breadcrumb-${item.name}`}
                href={item?.path}
                passHref
                aria-label={`breadcrumb ${item.name} link`}
              >
                <div
                  className={`text-black whitespace-nowrap text-xs uppercase font-medium hover:text-gray-900 lg:text-sm ${
                    index !== 0 && 'md:ml-2'
                  }`}
                >
                  <span
                    className={`${item.cssClassname ? item.cssClassname : ''}`}
                    suppressHydrationWarning={true}
                  >
                    {item.name}
                  </span>
                </div>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BreadCrumbs;
